import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'
import IRestaurantInfo from 'models/IRestaurantInfo'
import { CartItem } from 'models/IDeliveryOrder'

export interface CheckoutProps {}

export const useCheckout = (props: CheckoutProps) => {
  const { restaurantName } = useParams<{ restaurantName: string }>()

  const restaurantInfo: IRestaurantInfo | null = useSelector(
    (state: RootState) => state.restaurantInfo.restaurantInfo
  )
  const isLoading: boolean = useSelector(
    (state: RootState) => state.orders.isLoading
  )
  const isDeliveryOrderSuccess: boolean | null = useSelector(
    (state: RootState) => state.orders.isDeliveryOrderSuccess
  )
  const orderId: string | null = useSelector(
    (state: RootState) => state.orders.orderId
  )
  const totalPrice: number | null = useSelector(
    (state: RootState) => state.orders.totalPrice
  )
  const customerName: string | null = useSelector(
    (state: RootState) => state.orders.customerName
  )
  const cartItems: CartItem[] | null = useSelector(
    (state: RootState) => state.orders.cart
  )

  const currency = restaurantInfo?.currency
  const whatsappURL = restaurantInfo?.socialLinks.whatsapp

  return {
    ...props,
    restaurantName,
    cartItems,
    orderId,
    currency,
    totalPrice,
    customerName,
    whatsappURL,
    isLoading,
    isDeliveryOrderSuccess,
  }
}
